// SecretOutlet specific header events

var initialized = false,
    commonElements = require('./../../../app_storefront_core_UI/cartridge/js/common-elements'),
    util = require('./../../../app_storefront_core_UI/cartridge/js/util'),
    tls = require('./../../../app_storefront_core_UI/cartridge/js/tls'),
    $cache = {};

/**
 * @private
 * @function
 * @description Initializes cache for component
 */
if (document.querySelector(".b-main_navigation")) {
    function initializeCache() {
        $cache.body = document.querySelector("body");
        $cache.header = document.querySelector(".b-site_header-placeholder");
        $cache.headerOuter = document.querySelector("#header-outer");
    }

    module.exports = {
        init: function (params) {
            if (initialized) {
                return;
            }
            initializeCache();
            initializeEventsSO();
            initialized = true;
        }
    };

    /**
     * @private
     * @function
     * @description Initializes events for component
     */

    const navigationElement = document.querySelector(".b-main_navigation");
    const firstLvlListMob = document.querySelector(".b-navigation--mob");
    const firstLvlListDesk = document.querySelector(".b-navigation--desk");
    const allDrpdwnsList = firstLvlListDesk.querySelectorAll(".b-navigation-dropdown");
    const allTextFirstLvlListMob = firstLvlListMob.querySelectorAll(".b-navigation-top_link");
    const allTextFirstLvlListMobFirst = firstLvlListDesk.querySelectorAll(".b-navigation-link.m-level_2");
    const secondLvlListMob = document.querySelectorAll(".b-navigation-level_2");
    const thirdLvlListMob = document.querySelectorAll(".b-navigation-level_3");
    const allItemsSecondLvl = firstLvlListDesk.querySelectorAll(".b-navigation-column");
    const allFirstLvlList = firstLvlListDesk.querySelectorAll(".b-navigation-top_item");
    const allFirstLvlListMob = firstLvlListMob.querySelectorAll(".b-navigation-top_item");
    const hiddenElementsinMinimized = [".b-locale_menu", ".b-header-search"];
    const viewAllCategoriesinMob = firstLvlListDesk.querySelectorAll(".b-navigation-item");

    function initializeEventsSO() {
        defaultStart();
        setCurrentMenuItem(allFirstLvlList);
        initHeader();
        menuToggle();
    }

    //checking what is the default category: what was fixed with BM or should to choose MEN as default
    const checkDefaultCategory = (categories) => {
        const defaultCategory = Array.from(categories).filter((category) => category.classList.contains("b-navigation-active"));

        if (defaultCategory.length === 0 || defaultCategory.length > 1) {
            if (document.querySelector("#item-so-men")) {
                allFirstLvlList.forEach(element => element.classList.remove("b-navigation-active"));
                const menCategory = document.querySelector("#item-so-men");
                menCategory.classList.add("b-navigation-active");
            }
        }
    }

    //fix header height, remove arrows from mob
    const defaultStart = () => {
        const resize = () => {
            $cache.headerOuter.style.marginTop = $cache.header.offsetHeight + "px";
        }

        window.addEventListener("resize", resize);
        resize();
        removeArrowsMob(allItemsSecondLvl);
        checkDefaultCategory(allFirstLvlList);
    }

    const hideElementsJQuery = () => {
        hiddenElementsinMinimized.forEach(element => {
            $(element).hide(500);
        });
    }

    const showElementsJQuery = () => {
        hiddenElementsinMinimized.forEach(element => {
            $(element).show(500);
        });
    }

    //to show view-all menu items at the top
    const activateCategoriesinMob = () => {
        viewAllCategoriesinMob.forEach(element => {
            if (element.id.includes("-view_all") && element.parentElement.classList.contains("b-navigation-column")) {
                element.parentElement.classList.add("b-navigation-column--view-all");
            }
        });
    }

    //adding a class for body and minimizing header
    const initHeader = () => {
        $cache.body.classList.add("js-header_fixed");
        activateCategoriesinMob();
    }

    //removing arrows on mob
    const removeArrowsMob = (elements) => {
        elements.forEach(element => checkSubCatInside(element));
    };

    //removing arrows on mob
    const hideActiveCategoriesinMob = (elements) => {
        elements.forEach(element => element.classList.remove("b-navigation-active"));
    };

    //checking are there any categories inside
    const checkSubCatInside = (element) => {
        if (!element.querySelector(".b-navigation-level_3") && element.querySelector(".menu-item-toggle") && element.querySelector(".js-navigation-item")) {
            element.querySelector(".menu-item-toggle").classList.add("invisible");
            element.querySelector(".js-navigation-item").classList.add("full");
        }
    };

    //deactivate elements
    const deactivateElements = (dropdowns) => {
        dropdowns.forEach(elements => Array.from(elements).forEach(element => element.classList.remove("active")));
    };

    //toggling menu for mob
    const menuToggle = () => {
        const firstLvlHandler = (e) => {
            const target = e.target.id.replace(/mob-item-/i, '');
            if (firstLvlListDesk.querySelector(`#item-${target} .b-navigation-dropdown`)) {
                const targetEl = firstLvlListDesk.querySelector(`#item-${target} .b-navigation-dropdown`);
                const targetText = firstLvlListMob.querySelector(`#mob-item-${target} .b-navigation-top_link`);
                if (targetEl.classList.contains("active")) {
                    deactivateElements([thirdLvlListMob, allTextFirstLvlListMobFirst]);
                    targetEl.classList.remove("active");
                    targetText.classList.remove("active");
                } else {
                    deactivateElements([thirdLvlListMob, allDrpdwnsList, allTextFirstLvlListMob, allTextFirstLvlListMobFirst]);
                    targetEl.classList.add("active");
                    targetText.classList.add("active");
                }
            } else {
                deactivateElements([allDrpdwnsList, allTextFirstLvlListMob]);
            }
        };

        const secondLvlHandler = (e) => {
            if (e.target.tagName !== 'BUTTON') {
                return;
            }
            if (e.target.parentElement.querySelector(".b-navigation-level_3")) {
                const thirdLvlList = e.target.parentElement.querySelector(".b-navigation-level_3");
                const thirdLvlLink = e.target.parentElement.querySelector(".b-navigation-link.m-level_2");
                if (thirdLvlList.classList.contains("active")) {
                    deactivateElements([thirdLvlListMob, allTextFirstLvlListMobFirst]);
                } else {
                    deactivateElements([thirdLvlListMob, allTextFirstLvlListMobFirst]);
                    thirdLvlList.classList.add("active");
                    thirdLvlLink.classList.add("active");
                }
            } else {
                deactivateElements([allDrpdwnsList]);
            }
        };
        firstLvlListMob.addEventListener("click", firstLvlHandler);
        secondLvlListMob.forEach(menu => menu.addEventListener("click", secondLvlHandler));
    }

    //choosing a category via href
    const setCurrentMenuItem = (items) => {
        for (const item of items) {
            //first level checking
            const itemLinkFirstLvl = item.querySelector(".b-navigation-top_link");
            const linkHrefFirstLvl = itemLinkFirstLvl ? itemLinkFirstLvl.getAttribute("href") : null;

            let checking = window.location.href === linkHrefFirstLvl;

            //second level checking
            if (item.querySelectorAll(".b-navigation-link")) {
                const itemLinkSecondLvl = item.querySelectorAll(".b-navigation-link");
                const secondLvlMatch = Array.from(itemLinkSecondLvl).find((element) => element.getAttribute("href") === window.location.href);
                checking = window.location.href === linkHrefFirstLvl || secondLvlMatch;
            }

            //global matching
            if (checking) {
                hideActiveCategoriesinMob(allFirstLvlList);
                hideActiveCategoriesinMob(allFirstLvlListMob);
                deactivateElements([allDrpdwnsList, allTextFirstLvlListMob]);
                item.classList.add("b-navigation-active");

                if (item.querySelectorAll(".b-navigation-link.m-level_2")) {
                    const target = item.id;
                    const targetLink = firstLvlListMob.querySelector(`#mob-${target} .b-navigation-top_link`);
                    targetLink.classList.add("active");

                    if (firstLvlListDesk.querySelector(`#${target} .b-navigation-dropdown`)) {
                        const targetText = firstLvlListDesk.querySelector(`#${target} .b-navigation-dropdown`);
                        targetText.classList.add("active");
                    }
                }
            }
        }
    }
} else {
  module.exports = {
    init: function (params) {
        if (initialized) {
            return;
        }
        initialized = true;
    }
  };
}
